import React from "react";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import UiKitIcon from "@ui-kit/icon";
import Loading from "@ui-kit/loader/dots";
import AuthorComponent from "@radarly/components/author";
import { tr } from "@radarly/i18n";
import { FullInfluencer } from "@radarly/models/influencer";
import { Project } from "@radarly/models/project";

export interface SharedWidgetsPinnedAuthorProps {
  project: Project;
  author: FullInfluencer;
  setIsNarrow?: (isNarrow: boolean) => void;
  loading: boolean;
  isError: boolean;
  locale: Locale;
  timezone: Timezone;
  readOnly: boolean;
}
const Root = styled.div`
  height: 100%;
`;

const Info = styled.div`
  margin-top: 20px;
`;

const MsgContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-align: center;
`;

export default function SharedWidgetsPinnedAuthor({
  project,
  author,
  loading,
  isError,
  locale,
  timezone,
  readOnly = false,
}: SharedWidgetsPinnedAuthorProps) {
  return (
    <Root>
      {loading ? (
        <MsgContainer>
          <Loading />
        </MsgContainer>
      ) : isError ? (
        <MsgContainer>
          <UiKitIcon glyph="ghost" size={104} />
          <Info>{tr(locale, "PINNED_AUTHOR_CARD_PLACEHOLDER_ERROR")}</Info>
        </MsgContainer>
      ) : author ? (
        <AuthorComponent influencer={author.user} timezone={timezone} />
      ) : (
        <MsgContainer>
          {tr(locale, "PINNED_AUTHOR_CARD_PLACEHOLDER")}
        </MsgContainer>
      )}
    </Root>
  );
}
